// extracted by mini-css-extract-plugin
export var description = "portfolio-module--description--d050c";
export var orange = "portfolio-module--orange--afff0";
export var petrol = "portfolio-module--petrol--f67c5";
export var petrolToOrange = "portfolio-module--petrol-to-orange--5cf0c";
export var portfolio = "portfolio-module--portfolio--75bb5";
export var post = "portfolio-module--post--a9e10";
export var preview = "portfolio-module--preview--bd5c4";
export var purple = "portfolio-module--purple--fe420";
export var purpleToOrange = "portfolio-module--purple-to-orange--8e028";
export var titleHolder = "portfolio-module--titleHolder--e521e";